import React from 'react';
import { Popover, Radio } from 'antd';

import { chartAxes } from '../../constants/event';
import { sortingOrder } from '../../constants/common';

const RadioGroup = Radio.Group;

const createRadioGroup = (onChange, label, value, values) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span style={{ width: 50 }}>{label}:</span>
    <div style={{ width: 50 }}>
      <RadioGroup onChange={onChange} value={value}>
        {values.map((v) => (
          <Radio key={v} value={v}>
            {v}
          </Radio>
        ))}
      </RadioGroup>
    </div>
  </div>
);

const getContent = (onChange, showSortingOptions, { axis, order, sortingOptions }) => (
  <div>
    <div style={{ display: 'flex', flexDirection: 'column', paddingRight: 80 }}>
      {createRadioGroup(
        (v) => onChange({ axis: v.target.value, order, sortingOptions }),
        'Axis',
        axis,
        Object.values(chartAxes)
      )}
      {createRadioGroup(
        (v) => onChange({ axis, order: v.target.value, sortingOptions }),
        'Order',
        order,
        Object.values(sortingOrder)
      )}
    </div>
    {/* функционал с depend сортировкой пока не поддерживается */}
    {/* <div> */}
    {/*  { */}
    {/*    showSortingOptions ? */}
    {/*      createRadioGroup( */}
    {/*        v => onChange({sortingOptions: v.target.value, axis, order}), */}
    {/*        'Chart', */}
    {/*        sortingOptions, */}
    {/*        Object.values(options) */}
    {/*      ) */}
    {/*      : */}
    {/*      undefined */}
    {/*  } */}
    {/* </div> */}
  </div>
);

const ColumnChartSortingPopover = ({
  onChangeSorting,
  showSortingOptions,
  columnChartSorting,
  style = {},
}) => (
  <Popover
    placement="bottom"
    content={getContent(onChangeSorting, showSortingOptions, columnChartSorting)}
    trigger="click"
    getPopupContainer={(triggerNode) => triggerNode}
  >
    <a className="btn btn-primary" style={style}>
      Sorting
    </a>
  </Popover>
);

export default ColumnChartSortingPopover;
